import { Reveal } from "../components/Reveal";
import { Countdown } from "./Countdown";
import { useLang } from "../lib/i18n";

export const Welcome = () => {
  const { c } = useLang();
  return (
    <section className="py-28 sm:py-40 px-6" data-testid="welcome-section">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.35em] text-[#465220] mb-6">{c.welcome.overline}</p>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight max-w-2xl">
            {c.welcome.title}
            <span className="italic text-[#465220]">.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-14 max-w-2xl">
          <p className="text-base sm:text-lg leading-relaxed text-[#2C3552]/75 font-light">{c.welcome.body}</p>
          <p className="mt-6 font-serif-display italic text-xl text-[#2C3552]">{c.welcome.signoff}</p>
        </Reveal>
        <Countdown />
      </div>
    </section>
  );
};
